import { db } from "@/firebaseConfig";

const scheduleFoodCollection = db.collection("schedule_food");

const saveScheduleFood = async (id, data) => {
  scheduleFoodCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("ScheduleFood successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateScheduleFood = async (id, data) => {
  scheduleFoodCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("ScheduleFood successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteScheduleFood = async id => {
  scheduleFoodCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("ScheduleFood successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getScheduleFoodById = async id => {
  return scheduleFoodCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  scheduleFoodCollection,
  saveScheduleFood,
  updateScheduleFood,
  deleteScheduleFood,
  getScheduleFoodById
};
